import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Newsletter } from '@/domain/types/collections';
import useGetDocument from '@/domain/use-cases/get-document';
import AlertMessage from '@/presentation/components/alert-message';
import CommentsDetailDocument from '@/presentation/components/detail-document/comments';
import HeaderDetailDocument from '@/presentation/components/detail-document/header';
import StatsDetailDocument from '@/presentation/components/detail-document/stats';
import FormAddDocument from '@/presentation/components/form-add-document';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const NewsletterDetailsPage = () => {
  const [isAlertMessageOpen, setIsAlertMessageOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data,
    error,
    isLoading,
    updateDocument,
    deleteDocument,
    deleteComment,
    comments,
  } = useGetDocument<Newsletter>(DOCUMENTS_DB.NEWSLETTERS, id);

  const handleDelete = async () => {
    try {
      await deleteDocument();
      toast.success('Publicación eliminada correctamente', { theme: 'colored' });
      navigate('/dashboard/newsletters');
    } catch (error) {
      console.log(error);
      toast.error('Error al eliminar la publicación', { theme: 'colored' });
    }
  };

  const handleSave = async (updateData: Newsletter) => {
    try {
      const updatedData = { ...data, ...updateData };
      console.log(updatedData);
      await updateDocument(updatedData);
      toast.success('Noticia actualizada correctamente', { theme: 'colored' });
    } catch (error) {
      console.log(error);
      toast.error('Error al actualizar la noticia', { theme: 'colored' });
    }
  };

  if (isLoading) return <div>Loading...</div>;

  if (error) return <div>Error: {error}</div>;

  if (!data) return <div>No data</div>;

  return (
    <div className="p-4 flex flex-row md:flex-col gap-8">
      <HeaderDetailDocument
        title={data.title}
        handleDelete={() => setIsAlertMessageOpen(true)}
      />

      <StatsDetailDocument data={data} />

      <FormAddDocument
        onSave={handleSave as any}
        document={data}
        contentType="newsletter"
      />

      <div className="flex flex-col md:grid md:grid-cols-2 gap-4">
        <CommentsDetailDocument data={comments} deleteComment={deleteComment} />
      </div>

      <AlertMessage
        title="Eliminar Publicación"
        message="¿Estás seguro de querer eliminar esta publicación?"
        onConfirm={handleDelete}
        onCancel={() => setIsAlertMessageOpen(false)}
        isOpen={isAlertMessageOpen}
      />
    </div>
  );
};

export default NewsletterDetailsPage;
